<template>
  <div class="md-layout md-alignment-center-center">
    <!-- <div class="md-layout-item md-size-25">
          <img
            :src="conference.description[language.code].logoBrightImg"
            style="max-height:400px"
            class="img-circle"
          />
    </div>-->
    <div class="md-layout-item text-center md-size-75 md-small-size-95" style="padding:20px">
      <h1 class="text-white black">{{conference.description[language.code].name}}</h1>
      <h2
        class="text-white regular"
        v-if="conference.description[language.code].topic"
      >{{conference.description[language.code].topic}}</h2>
      <hr style="border:1px solid white;" />
      <h5 class="text-white black">{{conference.description[language.code].date}}</h5>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    })
  }
};
</script>